var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGitMerge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.086,35.245c-2.79,0-5.159,1.817-5.999,4.328H38.914c-0.84-2.511-3.209-4.328-6-4.328c-3.49,0-6.329,2.839-6.329,6.328 c0,3.49,2.839,6.329,6.329,6.329c2.79,0,5.16-1.817,6-4.329h11.923c-1.849,2.166-3.277,4.918-4.614,7.51 c-2.146,4.158-4.19,8.112-7.398,9.102c-0.908-2.384-3.211-4.086-5.911-4.086c-3.49,0-6.329,2.839-6.329,6.328 c0,3.49,2.839,6.329,6.329,6.329c2.852,0,5.267-1.897,6.056-4.495c5.438-0.969,8.281-6.446,10.808-11.344 c2.145-4.159,4.19-8.113,7.398-9.102c0.908,2.385,3.211,4.087,5.91,4.087c3.49,0,6.329-2.839,6.329-6.329 C69.415,38.083,66.576,35.245,63.086,35.245z M32.914,64.756c-1.284,0-2.329-1.045-2.329-2.329s1.044-2.328,2.329-2.328 s2.329,1.044,2.329,2.328S34.198,64.756,32.914,64.756z M32.914,43.901c-1.284,0-2.329-1.044-2.329-2.329 c0-1.284,1.044-2.328,2.329-2.328s2.329,1.044,2.329,2.328C35.243,42.857,34.198,43.901,32.914,43.901z M63.086,43.901 c-1.284,0-2.328-1.044-2.328-2.329c0-1.284,1.044-2.328,2.328-2.328s2.329,1.044,2.329,2.328 C65.415,42.857,64.37,43.901,63.086,43.901z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitMerge);
export default __webpack_public_path__ + "static/media/git-merge.7462cc1f596eedfa4ce7dd2dfafd4922.svg";
export { ForwardRef as ReactComponent };